import React, { useEffect, useState } from "react";
import "./Home_Explore_By_Category.css";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";

const Home_Explore_By_Category = (props) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(1);

  const dispatch = useDispatch();
  const categories = useSelector((state) => state.master.categories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const data = [
    {
      img: "/assets/images/home/explore_category/img3.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img4.png",
      product: "Baby Care",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
    {
      img: "/assets/images/home/explore_category/img1.png",
      product: "View All",
    },
  ];

  // Handle click
  const handleClick = (item, index) => {
    setActiveIndex(index);

    if (item === "View All") {
      navigate("/category"); // 👈 go to category page
    } else {
      navigate(
        `/product-listing/${item?.id}?category_name=${encodeURIComponent(
          item?.name
        )}&category_image=${encodeURIComponent(item?.image)}`
      ); // 👈 all other products go here
    }
  };

  return (
    <section className="Explore_By_Category Home_Explore_By_Category">
      <Common_Heading_Holder headingText={"Explore by Category"} />

      <div className="All_Vegitables_category">
        <div className="container">
          <div className="slidersec">
            {/* Swiper Slider */}
            <Swiper
              modules={[Navigation]}
              navigation={true}
              breakpoints={{
                0: { slidesPerView: 7, spaceBetween: 10 },
                350: { slidesPerView: 7, spaceBetween: 10 },
                575: { slidesPerView: 7, spaceBetween: 10 },
                768: { slidesPerView: 7, spaceBetween: 10 },
                991: { slidesPerView: 7, spaceBetween: 10 },
                1200: { slidesPerView: 7, spaceBetween: 50 },
                1400: { slidesPerView: 7, spaceBetween: 50 },
              }}
              className="mySwiper All_Vegitables_category_slider category_slider Home_Explore_By_Category_slider"
            >
              {categories.map((item, i) => (
                <SwiperSlide key={i}>
                  <div
                    className={`sliderdiv ${activeIndex === i + 1 ? "active" : ""}`}
                    onClick={() => handleClick(item, i + 1)}
                  >
                    <div
                      className={`imagediv ${activeIndex === i + 1 ? "active" : ""
                        }`}
                    >
                      <img
                        className="slider-img"
                        src={process.env.REACT_APP_IMG_URL + item.image}
                        alt={item.product}
                      />
                    </div>
                    <p className="catname">{item.name}</p>
                  </div>

                </SwiperSlide>

              ))}
              <SwiperSlide key={0}>
                <div
                  className={`sliderdiv ${activeIndex === 0 ? "active" : ""}`}
                  onClick={() => navigate("/category")}
                >
                  <div
                    className={`imagediv ${activeIndex === 0 ? "active" : ""
                      }`}
                  >
                    <img
                      className="slider-img"
                      src={'/assets/images/home/explore_category/img3.png'}
                      alt={"View all"}
                    />
                  </div>
                  <p className="catname">{"View all"}</p>
                </div>

              </SwiperSlide>
            </Swiper>


          </div>
          <div className="Home_Explore_By_Category_grid">
            <div className="row">
              {categories.map((item, i) => (
                <div className="col-md-4 col-sm-3 col-6" key={i}>
                  <div
                    className={`sliderdiv ${activeIndex === i + 1 ? "active" : ""}`}
                    onClick={() => handleClick(item, i + 1)}
                  >
                    <div
                      className={`imagediv ${activeIndex === i + 1 ? "active" : ""
                        }`}
                    >
                      <img
                        className="slider-img"
                        src={process.env.REACT_APP_IMG_URL + item.image}
                        alt={item.product}
                      />
                    </div>
                    <p className="catname">{item.name}</p>
                  </div>
                </div>
              ))}

              <div className="col-md-4 col-sm-3 col-6" key={0}>
                <div
                  className={`sliderdiv ${activeIndex === 0 ? "active" : ""}`}
                  onClick={() => navigate("/category")}
                >
                  <div
                    className={`imagediv ${activeIndex === 0 ? "active" : ""
                      }`}
                  >
                    <img
                      className="slider-img"
                      src={'/assets/images/home/explore_category/img3.png'}
                      alt={"View all"}
                    />
                  </div>
                  <p className="catname">{"View all"}</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home_Explore_By_Category;
